import i18n from '@/i18n'

export default [
  {
    path: '/notifications',
    component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/Notifications.vue'),
    meta: {
      noContextRequired: true
    },
    children: [
      {
        path: '',
        name: 'notificationsOverview',
        component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/Overview/NotificationsOverview.vue'),
        meta: {
          page: {
            title: i18n.t('label.notificationsOverview'),
            fullWidth: false
          }
        },
        props: true
      },
      {
        path: 'add',
        name: 'addNotification',
        component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/Detail/Forms/NotificationDetailForm.vue'),
        meta: {
          permissions: ['Portal.Notifications.Create'],
          page: {
            title: i18n.t('label.createNew{label}', { label: i18n.t('label.notification') }),
            fullWidth: false
          }
        },
        props: true
      },
      {
        path: ':reference',
        name: 'notificationDetail',
        component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/Detail/NotificationDetail.vue'),
        meta: {
          page: {
            title: i18n.t('label.{label}Details', { label: i18n.t('label.notification') }),
            fullWidth: false
          }
        },
        props: true
      },
      {
        path: 'edit/:reference',
        name: 'editNotification',
        component: () => import(/* webpackChunkName: "Notifications" */ '@/views/Notifications/Detail/Forms/NotificationDetailForm.vue'),
        meta: {
          permissions: ['Portal.Notifications.Read'],
          page: {
            title: i18n.t('label.edit{label}', { label: i18n.t('label.notification') }),
            fullWidth: false
          }
        },
        props: true
      }
    ]
  }
]
